import React from 'react';
import { IconProps } from '../types/types';

const PANW: React.FC<IconProps> = (props) => (
    <svg viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg" role="img" {...props}><path fill="#F0F3FA" d="M0 0h18v18H0z"/><path d="M7 4 2 9l1.99 1.99 5.01-5L7 4Zm0 10-1.99-1.99 5.02-5L9 6 11 4l1.98 1.98-5 5L9 12l-2 2Zm2-2 2 2 5-5-2-2-5 5Z" fill="#FA592D"/></svg>
);

export default PANW;